import { defineStore } from 'pinia';
import $api from '@/plugins/axios';

export const useStudyStore = defineStore('StudyStore', {
  state: () => {
    return {
      roomUsers: {
        content: [],
        pageInfo: {},
      },
      studyRoomUsersCount: {
        totalCount: 0,
        enterRate: 0,
      },
      premiumStudyHistory: {
        todayStudyTimeSeconds: 0,
        beforeTodayStudyTimeSeconds: 0,
        weekStudyTimeSeconds: 0,
        beforeWeekStudyTimeSeconds: 0,
        monthStudyTimeSeconds: 0,
        beforeMonthStudyTimeSeconds: 0,
        totalStudyTimeSeconds: 0,
      },
    };
  },
  actions: {
    /**
     * 접속 현황 API
     */

    /** 접속 중인 전체 학생 목록 조회 */
    async getStudyUsers(params) {
      try {
        const res = await $api.get('/room-users', { params });
        this.roomUsers = res;
      } catch (e) {
        this.$handleError(e);
      }
    },

    /** 현재 접속 인원 수 및 접속률 조회 */
    async getStudyUsersCount() {
      try {
        const res = await $api.get('/room-users/count');
        this.studyRoomUsersCount = res;
      } catch (e) {
        this.$nuxt.$sentry.captureException(e);
        this.$nuxt.error({ statusCode: e.response.status });
      }
    },

    /**
     * 공부 기록 API
     */

    /** 전체 학생 공부기록 목록 조회 */
    async getStudyHistories(params) {
      return await $api.get('/study-histories', { params });
    },

    /** 특정 학생의 프리미엄 공부기록 조회 */
    async getPremiumStudyHistory(params) {
      try {
        const res = await $api.get(`/study-histories/students/${params.userId}/premium`);
        this.premiumStudyHistory = res;
      } catch (e) {
        this.$handleError(e);
      }
    },

    /** 특정 학생의 전체 방 공부기록 목록 조회 */
    async getStudyHistoryRooms(params) {
      return await $api.get(`/study-histories/students/${params.userId}/studied-room`, { params });
    },

    /** 특정 학생의 전체 방 공부기록 전체 초기화 */
    // async resetStudyHistory(params) {
    //   try {
    //     await $api.put(`/study-histories/students/${params.userId}/reset`);
    //   } catch(e) {
    //     this.$handleError(e);
    //   }
    // },

    /** 특정 학생의 특정 방 공부기록 조회 */
    async getStudyHistoryDetailByRoomId(params) {
      return await $api.get(`/study-histories/rooms/${params.roomId}/users/${params.userId}`, { params });
    },

    /** 특정 학생의 특정 방 공부기록 수정 */
    async updateStudyHistory(params) {
      return await $api.put(`/study-histories/students/${params.userId}/rooms/${params.roomId}`, params);
    },
    $handleError(e) {
      this.$nuxt.$sentry.captureException(e);
      this.$nuxt.error({ statusCode: e.response.status });
    },
  },
  getters: {},
});
